import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store'
import 'bootstrap'
import '@/assets/scss/app.scss'
import '@fortawesome/fontawesome-free/js/all'
import i18n from './i18n'
import axios from 'axios'
import Select2 from 'vue3-select2-component';
import { VueMaskDirective } from "v-mask";

import VueAwesomePaginate from "vue-awesome-paginate";
// import "@vue-awesome-paginate/dist/style.css";

axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_APIURL

store.commit('initialize')

global.$ = global.jQuery = require('jquery')

const vMaskV2 = VueMaskDirective;
const vMaskV3 = {
	beforeMount: vMaskV2.bind,
	updated: vMaskV2.componentUpdated,
	unmounted: vMaskV2.unbind
};

if (!localStorage.getItem("sidebar-collapse")) {
	store.state.sidebarCollapse = window.screen.width < 1500;
} else {
	store.state.sidebarCollapse = localStorage.getItem("sidebar-collapse") ?? store.state.sidebarCollapse
}

window.addEventListener('resize', function (event) {
	store.state.sidebarCollapse = window.screen.width < 1500;
}, true)


createApp(App)
	.use(store)
	.use(i18n)
	.use(router)
	.directive('mask', vMaskV3)
	.component('Select2', Select2)
	.use(VueAwesomePaginate)
	.mount('#app')
